export default {"src":"/_next/static/media/hero_pop.f87b3303.gif","height":560,"width":960,"blurWidth":0,"blurHeight":0};